/* ==========================================================================
   TNF · Warenkorb-Schubfach oeffnen
   --------------------------------------------------------------------------
   Eine Aufgabe: nach einem Sammel-Kauf ("Alle Teile in den Warenkorb",
   "Haeufig zusammen gekauft") das Schubfach oeffnen und mit dem aktuellen
   Inhalt fuellen.

   WARUM ES DIESE DATEI GIBT (07.09.2026):
   Die Buttons haben vorher versucht, halo.updateSidebarCart() zu rufen. Das
   Objekt "halo" liegt aber in einer geschlossenen Funktion in theme.js und
   ist von aussen nicht erreichbar - der Aufruf lief also immer ins Leere.
   Ergebnis: die Teile lagen im Warenkorb, aber auf dem Bildschirm passierte
   nichts. Der Kunde klickt dann ein zweites Mal.

   Auch der Umweg ueber einen Klick auf das Warenkorb-Symbol taugt nicht:
   theme.js laedt den Inhalt dabei nur beim allerersten Klick nach
   (checkInitSideBarCart), danach oeffnet sich das Schubfach mit altem Stand.

   Deshalb macht diese Datei genau das, was Halo intern auch macht, nur
   direkt: sie holt /cart?view=ajax_side_cart und setzt das Ergebnis in den
   Kasten. Kein Zugriff auf Theme-Interna, beliebig oft wiederholbar.
   ========================================================================== */
(function () {
  'use strict';

  function wurzel() {
    var r = (window.routes && window.routes.root) ||
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.replace(/\/$/, '');
  }

  /* Holt den aktuellen Inhalt des Schubfachs und setzt ihn in den Kasten.
     Genau das macht Halo intern auch - nur ist halo.updateSidebarCart von
     aussen nicht erreichbar. */
  window.tnfRenderDrawer = function (cart) {
    var root = wurzel();
    var zaehler = document.querySelectorAll('[data-cart-count]');
    if (cart) {
      Array.prototype.forEach.call(zaehler, function (el) { el.textContent = cart.item_count; });
    }
    return fetch(root + '/cart?view=ajax_side_cart', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var kasten = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
        if (kasten) kasten.innerHTML = html;
        if (cart) document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
        return cart;
      });
  };

  /* ------------------------------------------------------- Zeile entfernen

     WARUM WIR DAS SELBST MACHEN (07.09.2026):
     Halo entfernt ueber den Zeilenschluessel ("54499778330949:5454a9..."),
     den es beim Rendern in data-line schreibt. Steht im Warenkorb inzwischen
     etwas anderes - der Kunde hatte zwei Tabs offen, eine Rabatt-App hat die
     Zeilen umgebaut, oder das Schubfach wurde einfach nicht nachgeladen -,
     dann zeigt der Schluessel ins Leere und Shopify antwortet mit
     "keine gueltigen ID- oder Zeilenparameter". Der Kunde klickt auf das X
     und bekommt einen gelben Fehlerbalken statt einer leeren Zeile.

     Deshalb: nicht ueber den Schluessel aus dem HTML, sondern ueber die
     Position der Zeile im GERADE abgerufenen Warenkorb. Die kann nicht
     veralten, weil sie eine Sekunde alt ist.

     Der Griff laeuft in der Einfangphase (capture) und stoppt Halos eigenen
     Handler - sonst wuerden beide feuern und einer davon scheitern.
  */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-cart-remove]') : null;
    if (!btn) return;
    if (!btn.closest('#halo-cart-sidebar')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var root = wurzel();
    var variante = String(btn.getAttribute('data-cart-remove-id') || '');
    var schluessel = String(btn.getAttribute('data-line') || '');
    var zeile = btn.closest('.previewCartItem') || btn.parentElement;
    if (zeile) zeile.style.opacity = '.45';

    fetch(root + '/cart.js', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var nr = 0;
        for (var i = 0; i < cart.items.length; i++) {
          /* Erst den genauen Schluessel suchen. Nur wenn der nicht mehr da
             ist, auf die Variante ausweichen - sonst erwischt man bei zwei
             Zeilen derselben Variante die falsche. */
          if (cart.items[i].key === schluessel) { nr = i + 1; break; }
        }
        if (!nr) {
          for (var j = 0; j < cart.items.length; j++) {
            if (String(cart.items[j].variant_id) === variante) { nr = j + 1; break; }
          }
        }
        if (!nr) {
          /* Die Zeile gibt es nicht mehr. Kein Fehler - nur neu zeichnen. */
          return window.tnfRenderDrawer(cart);
        }
        return fetch(root + '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: nr, quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(function (neu) { return window.tnfRenderDrawer(neu); });
      })
      .catch(function () {
        if (zeile) zeile.style.opacity = '';
        window.location.href = root + '/cart';
      });
  }, true);

  /* Legt Varianten in den Warenkorb und oeffnet danach das Schubfach.
     items: [{ id: Number, quantity: Number, properties?: {} }]
     Gibt ein Promise zurueck, damit der Aufrufer den Button wieder
     freigeben kann - auch im Fehlerfall. */
  window.tnfAddAndOpenCart = function (items) {
    var root = wurzel();

    return fetch(root + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'add failed'); });
        return fetch(root + '/cart.js', { cache: 'no-store' });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* Zaehler im Kopf sofort hochsetzen - das ist die schnellste
           sichtbare Rueckmeldung, noch bevor das Schubfach gerendert ist. */
        var zaehler = document.querySelectorAll('[data-cart-count]');
        Array.prototype.forEach.call(zaehler, function (el) { el.textContent = cart.item_count; });

        return window.tnfRenderDrawer(cart)
          .then(function () {
            document.body.classList.add('cart-sidebar-show');
            return cart;
          })
          .catch(function () {
            /* Inhalt liess sich nicht nachladen - dann wenigstens auf die
               Warenkorbseite, damit der Kunde sieht, dass etwas passiert ist. */
            window.location.href = root + '/cart';
            return cart;
          });
      });
  };
})();
